import { render, staticRenderFns } from "./User.Menu.Add.vue?vue&type=template&id=982bd16a&scoped=true&"
import script from "./User.Menu.Add.vue?vue&type=script&lang=js&"
export * from "./User.Menu.Add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982bd16a",
  null
  
)

export default component.exports